import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowRight, FiPlayCircle } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const VideoHero = () => {
  return (
    <section className="relative pt-48 pb-24 lg:pt-64 lg:pb-36 overflow-hidden bg-slate-950">
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-emerald-500/10 rounded-full blur-[150px] -mr-96 -mt-96 opacity-60" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-blue-500/10 rounded-full blur-[150px] -ml-48 -mb-48 opacity-40" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <span className="inline-flex items-center space-x-2 py-2 px-5 rounded-full bg-emerald-500/10 text-emerald-400 text-xs font-black mb-8 uppercase tracking-[0.2em] border border-emerald-500/20">
              <SafeIcon icon={FiPlayCircle} className="animate-pulse" />
              <span>AI Video Creation Service</span>
            </span>
            
            <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tight mb-8 leading-[1.1]">
              Scale Your Sales with <span className="text-emerald-400 text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-blue-400">High-Converting</span> AI Video Content
            </h1>
            
            <p className="text-xl text-slate-400 mb-12 leading-relaxed font-medium">
              Stop spending weeks on production. We build intelligent video systems that generate professional ads, product showcases, and social content in hours, not months.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-5">
              <a 
                href="https://go.digitalgigs.eu/chat" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full sm:w-auto flex items-center justify-center px-10 py-5 text-lg font-bold rounded-full text-slate-950 bg-emerald-400 hover:bg-emerald-300 transition-all shadow-2xl shadow-emerald-400/20 hover:-translate-y-1"
              >
                Get a Free Quote
                <SafeIcon icon={FiArrowRight} className="ml-3" />
              </a>
              <div className="flex items-center space-x-4 text-slate-400 font-bold">
                <span className="flex -space-x-2">
                  {[1,2,3].map(i => (
                    <div key={i} className="w-10 h-10 rounded-full border-2 border-slate-950 bg-slate-800" />
                  ))}
                </span>
                <span className="text-sm">Trusted by 50+ Brands</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="relative"
          >
            <div className="bg-slate-900 rounded-[2.5rem] border border-white/10 overflow-hidden shadow-2xl relative group flex items-center justify-center aspect-[4/5] md:aspect-square lg:aspect-auto lg:h-[600px]">
              <video 
                src="https://media-manager-c.questera.ai/greta-media/fafed1dc96bdeaff472e762fc9535f37237b73cd078ba929908d8fc9f91ee4faeb3717965c5074a04f18e80ee0d17e20/videos/dmlkZW8vbXA0/3113eb0665ee2139533009a1a6f32fcb.mp4"
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-contain opacity-80 group-hover:scale-105 transition-transform duration-700 block"
              />
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="w-20 h-20 bg-emerald-400/20 backdrop-blur-md rounded-full flex items-center justify-center text-emerald-300 text-3xl shadow-2xl shadow-emerald-400/20 border border-emerald-400/30">
                  <SafeIcon icon={FiPlayCircle} />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VideoHero;
